<template>
    <div id="chartNotFound">
        <div class="svg-container">
            <svg
                viewBox="0 0 1049 372"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
            >
                <g id="backtracking" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                    <g id="Artboard" transform="translate(-5798.000000, -2590.000000)">
                        <g id="Group" transform="translate(5799.000000, 2590.000000)">
                            <line
                                x1="0.5"
                                y1="243.5"
                                x2="1045.5"
                                y2="243.5"
                                id="Line"
                                stroke="#E7EBF1"
                                stroke-linecap="square"
                            ></line>
                            <line
                                x1="0.5"
                                y1="121.5"
                                x2="1045.5"
                                y2="121.5"
                                id="Line"
                                stroke="#E7EBF1"
                                stroke-linecap="square"
                            ></line>
                            <line
                                x1="0.5"
                                y1="0.5"
                                x2="1045.5"
                                y2="0.5"
                                id="Line"
                                stroke="#E7EBF1"
                                stroke-linecap="square"
                            ></line>
                            <path
                                d="M1,243 C32.2894762,166.89952 66.4561429,128.39952 103.5,127.5 C159.065786,126.15072 144.621905,258.709577 227,238 C309.378095,217.290423 287.861621,43.5134257 372,60 C456.138379,76.4865743 446.98965,296 523,296 C599.01035,296 625.688884,78.5932385 676,60 C726.311116,41.4067615 736.906606,193.503253 799,194 C861.093394,194.496747 862.366139,59.6813573 926,62 C968.422574,63.5457618 1008.42257,111.545762 1046,206 L1046,372 L1,372 L1,243 Z"
                                id="Line-2"
                                fill-opacity="0.666111233"
                                fill="#F8F9FB"
                            ></path>
                            <path
                                d="M1,243 C32.2894762,166.89952 66.4561429,128.39952 103.5,127.5 C159.065786,126.15072 144.621905,258.709577 227,238 C309.378095,217.290423 287.861621,43.5134257 372,60 C456.138379,76.4865743 446.98965,296 523,296 C599.01035,296 625.688884,78.5932385 676,60 C726.311116,41.4067615 736.906606,193.503253 799,194 C861.093394,194.496747 862.366139,59.6813573 926,62 C968.422574,63.5457618 1008.42257,111.545762 1046,206"
                                id="Line-2"
                                stroke="#ABB9CD"
                                stroke-width="2"
                                stroke-linecap="square"
                            ></path>
                        </g>
                    </g>
                </g>
            </svg>
        </div>
        <div class="not-found-content">
            <div class="image-container">
                <img src="/static/img/empty-chart.png" />
            </div>
            <div class="alert-text">
                {{ title || $t("chatbotv2.inMaintenance") }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ChartNotFound",
    props: {
        title: {
            type: String,
            required: false,
        },
    },
};
</script>

<style lang="scss">
#chartNotFound {
    position: relative;
    user-select: none;

    .svg-container {
        opacity: 0.4;
    }

    .not-found-content {
        top: 50%;
        left: 50%;
        transform: translate(-50%);
        position: absolute;

        .image-container {
            width: 300px;

            img {
                width: 100%;
            }
        }

        .alert-text {
            text-align: center;
            margin-top: 20px;
            font-size: 27px;
        }
    }
}
</style>
